<template>
  <div class="com-debug-panel">
    <h2>DEBUG ENTRY</h2>

    <p>
      <vux-input
          v-model="cpCode"
          placeholder="请输入测评code:"
          title="测评code："
          type="number"
      ></vux-input>
    </p>

    <section class="links">
      <router-link
          :to="`/survey/entry?code=${cpCode}`"
      >
        <one-button
            type="primary"
            plain
        >
          Entry
        </one-button>
      </router-link>

      <router-link
          :to="`/survey/chat?code=${cpCode}`"
      >
        <one-button
            type="primary"
        >
          Chat
        </one-button>
      </router-link>

      <router-link
          :to="`/survey/mine?code=${cpCode}`"
      >
        <one-button
            type="default"
            plain
        >
          Mine
        </one-button>
      </router-link>

      <router-link
          :to="`/survey/detail?code=${cpCode}`"
      >
        <one-button
            type="warn"
        >
          Detail
        </one-button>
      </router-link>

      <one-button
          type="warn"
          @click.native="_deleteCookie"
          plain
      >
        Delete Cookie
      </one-button>
    </section>

    <div class="debug-text">
      <sup>
        [BUILT] {{ builtDate }}
      </sup>
      <br> <br>
      {{ JSON.stringify(envs) }}
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import VuxInput from 'vux/src/components/x-input/index'

  export default {
    name: 'DebugPanel',

    data () {
      return {
        cpCode: 1,
        builtDate: process.env.BUILT_DATE,
        envs: process.env,
        timer: (new Date()).toTimeString(),
        agent: navigator.userAgent
      }
    },

    created () {
    },

    mounted () {
    },

    methods: {
      _deleteCookie () {
        if (!confirm('confirm delete YLY_AUTH cookie')) {
          return
        }

        setTimeout(() => {
          Cookies.remove('yly_auth')
          Cookies.remove('yly_auth', {
            path: '/',
            domain: '.doctopia.com.cn'
          })

          setTimeout(() => {
            window.alert(Cookies.get('yly_auth'))
          }, 1000)
        }, 200)
      },
    },

    components: {
      VuxInput
    }
  }
</script>

<style lang="scss">
  .com-debug-panel {
    padding: 50px;
  }
</style>

